import { httpPost } from "../../../../../../../Utils/apis/apis";
import { subdomain } from "../../../../../Atoms/DataDisplay/DataGrid/helper/download.helper";
export const fileListWithDisplayName = (fileList) => {
  let listwithdisplayname = [];
  if (fileList) {
    fileList.map((file) => {
      let fileArr = file.file.split("/");
      file = { ...file, fileDisplayName: fileArr.slice(-1)[0] };
      listwithdisplayname.push(file);
    });
  }
  return listwithdisplayname;
};
export const sortFiles = ({ data, sorting }) => {
  const { on, orderBy = "asc" } = sorting || {};
  return data?.sort((a, b) => {
    const orderFactor = orderBy === "asc" ? 1 : -1;
    let orderOn = on && a[on] && b[on] ? on : "fileDisplayName";
    return orderFactor * (a[orderOn].localeCompare(b[orderOn]) || 0);
  });
};

export const downloadDocument = async (
  e,
  type = "generic",
  additionDownloadHelper
) => {
  let documentName = e.file;
  let url = `${process.env.DOCUMENT_HELPER}`;
  if (documentName.includes("//")) {
    documentName = documentName.replace(/\/\//g, "/");
  }
  let header = {
    filename: documentName,
    type: type,
    "file-operation": "download",
    "process-file": "yes",
    "x-functions-key": process.env.DOCUMENT_HELPER_KEY,
    subdomain: subdomain,
  };

  if (additionDownloadHelper) {
    let { extraHeaders = {}, apiUrl } = additionDownloadHelper;
    header = { ...header, ...extraHeaders };
    url = apiUrl || url;
  }
  await httpPost(
    url,
    {
      method: "GET",
    },
    { responseType: "blob", headers: header }
  ).then((response) => {
    const url1 = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url1;
    link.setAttribute("download", e.fileDisplayName);
    document.body.appendChild(link);
    link.click();
  });
};
export const onDeleteDocument = async (e, type = "generic") => {
  const documentName = e.file;
  const url = `${process.env.DOCUMENT_HELPER}`;
  let header = {
    filename: documentName,
    type: type,
    "file-operation": "delete",
    "process-file": "no",
    "x-functions-key": process.env.DOCUMENT_HELPER_KEY,
    subdomain: subdomain,
  };
  await httpPost(
    url,
    {
      method: "GET",
    },
    { responseType: "blob", headers: header }
  );
};
